import { useVenti } from 'venti'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { getTheme } from '../../../config'
import Page from '../../../components/Page'
import { AppContextState } from '../../../types'
import { Footer } from '../../../components/Footer'
import { useAppContext } from '../../../components/AppContext'
import { navigationLinking } from '../../../services/navigation'
import PortalHeader from '../../../components/portal/PortalHeader'
import ModalNewUser from '../../../components/modals/ModalNewUser'
import ModalAppError from '../../../components/modals/ModalAppError'
import ModalTutorial from '../../../components/modals/ModalTutorial'
import ModalEConsent from '../../../components/modals/ModalEConsent'
import ModalLoanDraft from '../../../components/modals/ModalLoanDraft'
import ModalAppPosting from '../../../components/modals/ModalAppPosting'
import PortalActionCards from '../../../components/portal/PortalActionCards'
import ModalInviteBorrower from '../../../components/modals/ModalInviteBorrower'
import ModalWorkflowSelector from '../../../components/modals/ModalWorkflowSelector'

const theme = getTheme()

export default function Portal() {
	const navigate = useNavigate()
	const ventiState = useVenti()
	const { state } = useAppContext()
	const { siteConfig, socialLinks, legalLinks, user } =
		state as unknown as AppContextState

	const appSubmitted = ventiState.get(theme.storageKeys.appSubmitted)

	const failoverModalVisible = ventiState.get(
		theme.storageKeys.failoverModalVisible
	)

	useEffect(() => {
		if (!user?.isLoggedIn) {
			navigate(`/${navigationLinking.SignIn}`)
		}
	}, [user?.isLoggedIn, navigate])

	return (
		<>
			<Page
				page="app-portal"
				title="Portal"
				isFullWidth
				hideSubHeader
			>
				<PortalHeader />
				<PortalActionCards />
				<hr className="border-b-2" />
				<Footer
					siteConfig={siteConfig || undefined}
					socialLinks={socialLinks}
					legalLinks={legalLinks}
				/>
			</Page>

			<ModalInviteBorrower />

			<ModalLoanDraft />

			<ModalAppPosting />

			<ModalNewUser />

			<ModalTutorial />

			<ModalEConsent />

			<ModalWorkflowSelector />

			<ModalAppError
				visible={!appSubmitted && failoverModalVisible}
				siteConfig={siteConfig}
			/>
		</>
	)
}
